module.exports = __webpack_public_path__ + "static/img/loyaltyvenue.dff186d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/loyaltyvenue.svg
// module id = 8Mmf
// module chunks = 13